module.exports = __webpack_public_path__ + "img/badge_color_highered-finance.a5d855ce.svg";